import {
  GETTAXRETURNTYPEMASTER,
  CREATETAXRETURNTYPEMASTER,
  UPDATETAXRETURNTYPEMASTER,
  DELETETAXRETURNTYPEMASTER,
  GETTAXTDSSECTIONMASTER,
  CREATETAXTDSSECTIONMASTER,
  UPDATETAXTDSSECTIONMASTER,
  DELETETAXTDSSECTIONMASTER,
  GETTAXTCSSECTIONMASTER,
  CREATETAXTCSSECTIONMASTER,
  UPDATETAXTCSSECTIONMASTER,
  DELETETAXTCSSECTIONMASTER,
  GETTAXMASTER,
  CREATETAXMASTER,
  UPDATETAXMASTER,
  DELETETAXMASTER,

  CREATEPRODUCT,
  CREATEPRODUCTGROUP,
  DELETEPRODUCT,
  DELETEPRODUCTGROUP,
  GETPRODUCT,
  GETPRODUCTGROUP,
  UPDATEPRODUCT,
  UPDATEPRODUCTGROUP,
  GETSPECIFICATION,
  CREATESPECIFICATION,
  UPDATESPECIFICATION,
  DELETESPECIFICATION,
  GETPROMOCODE,
  CREATEPROMOCODE,
  UPDATEPROMOCODE,
  DELETEPROMOCODE,
  GETPPRODUCTPACKAGE,
  CREATEPPRODUCTPACKAGE,
  UPDATEPPRODUCTPACKAGE,
  DELETEPPRODUCTPACKAGE,
  GETPPRODUCTTAX,
  CREATEPPRODUCTTAX,
  UPDATEPPRODUCTTAX,
  DELETEPPRODUCTTAX,
  GETPPRODUCTTAXTYPE,
  CREATEPPRODUCTTAXTYPE,
  UPDATEPPRODUCTTAXTYPE,
  DELETEPPRODUCTTAXTYPE,
  VERIFY_AND_SAVE_PAYMENT,
  CREATE_RAZORPAY_ORDER,
  CREATE_CASHFREE_ORDER,
  GETSPECIFICATIONTYPE,
  CREATESPECIFICATIONTYPE,
  UPDATESPECIFICATIONTYPE,
  DELETESPECIFICATIONTYPE,
  GETTRANSACTIONINFORMATION,
  GETSPECIALIZATION,
  CREATESPECIALIZATION,
  UPDATESPECIALIZATION,
  DELETESPECIALIZATION,
  GETPRODUCTSETUPDEPARTMENT,
  CREATEPRODUCTSETUPDEPARTMENT,
  UPDATEPRODUCTSETUPDEPARTMENT,
  DELETEPRODUCTSETUPDEPARTMENT,
  GETPRODUCTSETUPROLE,
  CREATEPRODUCTSETUPROLE,
  UPDATEPRODUCTSETUPROLE,
  DELETEPRODUCTSETUPROLE,
  GETPRODUCTSETUPROLETYPE,
  CREATEPRODUCTSETUPROLETYPE,
  UPDATEPRODUCTSETUPROLETYPE,
  DELETEPRODUCTSETUPROLETYPE,
  CREATEDURATION,
  GETDURATION,
  DELETEDURATION,
  UPDATEDURATION,
  GETPAYMENTMODE,
  CREATEPAYMENTMODE,
  UPDATEPAYMENTMODE,
  DELETEPAYMENTMODE,
  CREATEPRODUCTSPECIALITY,
  GETPRODUCTSPECIALITY,
  UPDATEPRODUCTSPECIALITY,
  DELETEPRODUCTSPECIALITY,
  GETAllPRODUCTSPECIALITY,
  axios,
  baseURL,
  ServiceURL,
  CREATEPRODUCTLANGUAGE,
  GETPRODUCTLANGUAGE,
  UPDATEPRODUCTLANGUAGE,
  DELETEPRODUCTLANGUAGE,
  CREATEPRODUCTCURRENCY,
  GETPRODUCTCURRENCY,
  UPDATEPRODUCTCURRENCY,
  DELETEPRODUCTCURRENCY,
  GETALLCONFIG,
  GETCONTROLPRODUCTBYNAME,
  GETSEARCHCONTROLPRODUCT,
} from "./types";

const makeApiRequest = (config, dispatch, type) => {
  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        if (dispatch && type) {
          dispatch({
            type: type,
            payload: response.data,
          });
        }
        resolve(response.data);
      })
      .catch((error) => {
        console.error(`API Error for ${config.url}:`, error);
        reject(error);
      });
  });
};

export const createProductGroup = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductgroup/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTGROUP);
};

export const getProductGroup = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductgroup/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTGROUP);
};

export const updateProductGroup = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductgroup/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTGROUP);
};

export const deleteProductGroup = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductgroup/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        dispatch({
          type: DELETEPRODUCTGROUP,
          payload: response.data,
          productId: data.id,
        });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createProduct = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproduct/createall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCT);
};

export const getProduct = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproduct/getallproduct",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCT);
};

export const updateProduct = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproduct/updateall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCT);
};

export const deleteProduct = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproduct/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPRODUCT);
};

export const createSpecification = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecification/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATESPECIFICATION);
};

export const getSpecification = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecification/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETSPECIFICATION);
};

export const updateSpecification = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductspecification/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATESPECIFICATION);
};

export const deleteSpecification = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductspecification/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        dispatch({
          type: DELETESPECIFICATION,
          payload: response.data,
          specificationId: data.id,
        });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createPromoCode = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductpromocode/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPROMOCODE);
};

export const getPromoCode = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductpromocode/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPROMOCODE);
};

export const updatePromoCode = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductpromocode/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPROMOCODE);
};

export const deletePromoCode = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductpromocode/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        dispatch({
          type: DELETEPROMOCODE,
          payload: response.data,
          promoId: data.id,
        });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createProductPackage = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/hospitalProductPackage/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPPRODUCTPACKAGE);
};

export const getProductPackage = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/hospitalProductPackage/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPPRODUCTPACKAGE);
};

export const updateProductPackage = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/hospitalProductPackage/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPPRODUCTPACKAGE);
};

export const deleteProductPackage = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/hospitalProductPackage/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        dispatch({
          type: DELETEPPRODUCTPACKAGE,
          payload: response.data,
          packageId: data.id,
        });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createProductTax = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuptaxgroupmaster/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPPRODUCTTAX);
};

export const getProductTax = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuptaxgroupmaster/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPPRODUCTTAX);
};

export const updateProductTax = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setuptaxgroupmaster/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPPRODUCTTAX);
};

export const deleteProductTax = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setuptaxgroupmaster/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPPRODUCTTAX);
};

export const createProductTaxType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuptaxtypemaster/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPPRODUCTTAXTYPE);
};

export const getProductTaxType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuptaxtypemaster/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPPRODUCTTAXTYPE);
};

export const updateProductTaxType = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setuptaxtypemaster/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPPRODUCTTAXTYPE);
};

export const deleteProductTaxType = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setuptaxtypemaster/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPPRODUCTTAXTYPE);
};

export const createRazorpayOrder = (orderData) => (dispatch) => {
  const config = {
    method: "post",
    url: ServiceURL + "/api/hospitalpayments/paymentorder",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: orderData,
  };
  return makeApiRequest(config);
};

export const createCashfreeOrder = (orderData) => (dispatch) => {
  const config = {
    method: "post",
    url: ServiceURL + "/api/hospitalpayments/paymentorder",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: orderData,
  };
  return makeApiRequest(config);
};
export const createCCAvenueOrder = (orderData) => (dispatch) => {
  const config = {
    method: "post",
    url: ServiceURL + "/api/hospitalpayments/paymentorder",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: orderData,
  };
  return makeApiRequest(config);
};
export const createSpecificationType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecificationtype/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, CREATESPECIFICATIONTYPE);
};

export const getSpecificationType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecificationtype/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETSPECIFICATIONTYPE);
};

export const updateSpecificationType = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductspecificationtype/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, UPDATESPECIFICATIONTYPE);
};

export const deleteSpecificationType = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductspecificationtype/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, DELETESPECIFICATIONTYPE);
};

export const getPaymentInformation = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuptransactions/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETSPECIALIZATION);
};

export const createSpecialization = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecialization/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, CREATESPECIALIZATION);
};

export const getSpecialization = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductspecialization/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETSPECIALIZATION);
};

export const updateSpecialization = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductspecialization/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, UPDATESPECIALIZATION);
};

export const deleteSpecialization = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductspecialization/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, DELETESPECIALIZATION);
};

export const createDepartment = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductdepartment/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTSETUPDEPARTMENT);
};

export const getDepartment = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductdepartment/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTSETUPDEPARTMENT);
};

export const updateDepartment = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductdepartment/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTSETUPDEPARTMENT);
};

export const deleteDepartment = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductdepartment/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };

  return axios(config)
    .then((response) => {
      dispatch({
        type: DELETEPRODUCTSETUPDEPARTMENT,
        payload: response.data,
        departmentId: data.id,
      });
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};

export const createproductsetupRole = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductrole/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTSETUPROLE);
};

export const getproductsetupRole = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductrole/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTSETUPROLE);
};

export const updateproductsetupRole = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductrole/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTSETUPROLE);
};

export const deleteproductsetupRole = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductrole/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };

  return makeApiRequest(config, dispatch, DELETEPRODUCTSETUPROLE).then(
    (response) => {
      dispatch({
        type: DELETEPRODUCTSETUPROLE,
        payload: response,
        roleId: data.id,
      });
      return response;
    },
  );
};

export const createproductsetupRoleType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductroletype/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTSETUPROLETYPE);
};

export const getproductsetupRoleType = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupproductroletype/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTSETUPROLETYPE);
};

export const updateproductsetupRoleType = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupproductroletype/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTSETUPROLETYPE);
};

export const deleteproductsetupRoleType = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupproductroletype/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data,
  };
  return makeApiRequest(config, dispatch, DELETEPRODUCTSETUPROLETYPE);
};

export const createDuration = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "post",
    url: baseURL + "/api/setupproductdiscount/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEDURATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getDuration = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupproductdiscount/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETDURATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateDuration = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "patch",
    url: baseURL + "/api/setupproductdiscount/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEDURATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteDuration = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupproductdiscount/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEDURATION,
        payload: response.data,
        durationId: data.id,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const createPaymentMode = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/PaymentMode/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPAYMENTMODE);
};

export const getPaymentMode = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/PaymentMode/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPAYMENTMODE);
};

export const updatePaymentMode = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/PaymentMode/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPAYMENTMODE);
};

export const deletePaymentMode = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/PaymentMode/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return makeApiRequest(config, dispatch, DELETEPAYMENTMODE).then(
    (response) => {
      dispatch({
        type: DELETEPAYMENTMODE,
        payload: response,
        paymentModeId: data.id,
      });
      return response;
    },
  );
};
export const createSpeciality = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuproductspecialization/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEPRODUCTSPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSpeciality = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuproductspecialization/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPRODUCTSPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateSpeciality = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuproductspecialization/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEPRODUCTSPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSpeciality = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuproductspecialization/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEPRODUCTSPECIALITY,
        payload: response.data,
        specialityId: data.id,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const createproductLanguage = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuplanguage/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTLANGUAGE);
};

export const getproductLanguage = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setuplanguage/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTLANGUAGE);
};

export const updateproductLanguage = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setuplanguage/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTLANGUAGE);
};

export const deleteproductLanguage = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setuplanguage/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPRODUCTLANGUAGE).then((res) => {
    dispatch({
      type: DELETEPRODUCTLANGUAGE,
      payload: res,
      languageId: data.id,
    });
    return res;
  });
};

export const createproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/Currency/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTCURRENCY);
};

export const getproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/Currency/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETPRODUCTCURRENCY);
};

export const updateproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/Currency/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTCURRENCY);
};

export const deleteproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/Currency/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPRODUCTCURRENCY).then((res) => {
    dispatch({
      type: DELETEPRODUCTCURRENCY,
      payload: res,
      currencyId: data.id,
    });
    return res;
  });
};

export const getTaxReturnTypeMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setupreturntypemaster/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return makeApiRequest(config, dispatch, GETTAXRETURNTYPEMASTER);
};
export const createTaxReturnTypeMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setupreturntypemaster/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATETAXRETURNTYPEMASTER);
};
export const updateTaxReturnTypeMaster = (data) => (dispatch) => {
  const config = {
    method: "patch", url: baseURL + "/api/setupreturntypemaster/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATETAXRETURNTYPEMASTER);
};
export const deleteTaxReturnTypeMaster = (data) => (dispatch) => {
  const config = {
    method: "delete", url: baseURL + "/api/setupreturntypemaster/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return new Promise((resolve, reject) => { axios(config).then((response) => { dispatch({ type: DELETETAXRETURNTYPEMASTER, payload: response.data, productId: data.id, }); resolve(response.data); }).catch((error) => { reject(error); }); });
};
export const getTaxTdsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptdssectionmaster/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return makeApiRequest(config, dispatch, GETTAXTDSSECTIONMASTER);
};
export const createTaxTdsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptdssectionmaster/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATETAXTDSSECTIONMASTER);
};
export const updateTaxTdsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "patch", url: baseURL + "/api/setuptdssectionmaster/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATETAXTDSSECTIONMASTER);
};
export const deleteTaxTdsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "delete", url: baseURL + "/api/setuptdssectionmaster/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return new Promise((resolve, reject) => { axios(config).then((response) => { dispatch({ type: DELETETAXTDSSECTIONMASTER, payload: response.data, productId: data.id, }); resolve(response.data); }).catch((error) => { reject(error); }); });
};
export const getTaxTcsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptcssectionmaster/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return makeApiRequest(config, dispatch, GETTAXTCSSECTIONMASTER);
};
export const createTaxTcsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptcssectionmaster/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATETAXTCSSECTIONMASTER);
};
export const updateTaxTcsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "patch", url: baseURL + "/api/setuptcssectionmaster/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATETAXTCSSECTIONMASTER);
};
export const deleteTaxTcsSectionMaster = (data) => (dispatch) => {
  const config = {
    method: "delete", url: baseURL + "/api/setuptcssectionmaster/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return new Promise((resolve, reject) => { axios(config).then((response) => { dispatch({ type: DELETETAXTCSSECTIONMASTER, payload: response.data, productId: data.id, }); resolve(response.data); }).catch((error) => { reject(error); }); });
};
export const getTaxMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptaxmaster/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return makeApiRequest(config, dispatch, GETTAXMASTER);
};
export const createTaxMaster = (data) => (dispatch) => {
  const config = {
    method: "post", url: baseURL + "/api/setuptaxmaster/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATETAXMASTER);
};
export const updateTaxMaster = (data) => (dispatch) => {
  const config = {
    method: "patch", url: baseURL + "/api/setuptaxmaster/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATETAXMASTER);
};
export const deleteTaxMaster = (data) => (dispatch) => {
  const config = {
    method: "delete", url: baseURL + "/api/setuptaxmaster/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", },
    data: data,
  };
  return new Promise((resolve, reject) => { axios(config).then((response) => { dispatch({ type: DELETETAXMASTER, payload: response.data, productId: data.id, }); resolve(response.data); }).catch((error) => { reject(error); }); });
};